import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './profile.css';
import { usePopup } from '../../contexts/PopupContext';

function Profile() {
  const navigate = useNavigate();
  const { showPopup } = usePopup();
  const [email, setEmail] = useState('');
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
      return;
    }

    const fetchUserInfo = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/auth/profile`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setUserInfo(response.data);
        setEmail(response.data.email);
      } catch (error) {
        if (error.response?.status === 401) {
          localStorage.removeItem('token');
          navigate('/login');
        } else {
          showPopup({
            type: 'error',
            title: 'Lỗi',
            message: 'Không thể tải thông tin người dùng',
            showCancelButton: false
          });
        }
      }
    };

    fetchUserInfo();
  }, [navigate, showPopup]);

  const handleUpdateEmail = async (e) => {
    e.preventDefault();
    if (!currentPassword) {
      showPopup({
        type: 'error',
        title: 'Lỗi',
        message: 'Vui lòng nhập mật khẩu hiện tại',
        showCancelButton: false
      });
      return;
    }

    setIsLoading(true);
    try {
      const token = localStorage.getItem('token');
      await axios.put(
        `${process.env.REACT_APP_API_URL}/auth/update-email`,
        { email, currentPassword },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      showPopup({
        type: 'success',
        title: 'Thành công',
        message: 'Email đã được cập nhật',
        showCancelButton: false
      });
      
      setCurrentPassword('');
    } catch (error) {
      showPopup({
        type: 'error',
        title: 'Lỗi',
        message: error.response?.data?.error || 'Có lỗi xảy ra khi cập nhật email',
        showCancelButton: false
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleUpdatePassword = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      showPopup({
        type: 'error',
        title: 'Lỗi',
        message: 'Mật khẩu xác nhận không khớp',
        showCancelButton: false
      });
      return;
    }

    if (newPassword.length < 6) {
      showPopup({
        type: 'error',
        title: 'Lỗi',
        message: 'Mật khẩu mới phải có ít nhất 6 ký tự',
        showCancelButton: false
      });
      return;
    }

    setIsLoading(true);
    try {
      const token = localStorage.getItem('token');
      await axios.put(
        `${process.env.REACT_APP_API_URL}/auth/update-password`,
        { currentPassword, newPassword },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      showPopup({
        type: 'success',
        title: 'Thành công',
        message: 'Mật khẩu đã được cập nhật',
        showCancelButton: false
      });
      
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (error) {
      showPopup({
        type: 'error',
        title: 'Lỗi',
        message: error.response?.data?.error || 'Có lỗi xảy ra khi cập nhật mật khẩu',
        showCancelButton: false
      });
    } finally {
      setIsLoading(false);
    }
  };

  if (!userInfo) return null;

  return (
    <div className="profile-container">
      <div className="profile-header">
        <h1>Thông tin tài khoản</h1>
        <p>Quản lý thông tin tài khoản của bạn</p>
      </div>

      <div className="profile-content">
        <div className="profile-section">
          <h2>Đổi email</h2>
          {userInfo && (
            <div className="current-email">
              <label>Email hiện tại</label>
              <div className="current-email-value">{userInfo.email}</div>
            </div>
          )}
          <form onSubmit={handleUpdateEmail}>
            <div className="form-group">
              <label>Email mới</label>
              <input
                type="email"
                className="form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label>Mật khẩu hiện tại</label>
              <input
                type="password"
                className="form-control"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                required
              />
            </div>
            <button 
              type="submit" 
              className="btn btn-primary"
              disabled={isLoading}
            >
              {isLoading ? 'Đang cập nhật...' : 'Cập nhật email'}
            </button>
          </form>
        </div>

        <div className="profile-section">
          <h2>Đổi mật khẩu</h2>
          <form onSubmit={handleUpdatePassword}>
            <div className="form-group">
              <label>Mật khẩu hiện tại</label>
              <input
                type="password"
                className="form-control"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label>Mật khẩu mới</label>
              <input
                type="password"
                className="form-control"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
                minLength={6}
              />
            </div>
            <div className="form-group">
              <label>Xác nhận mật khẩu mới</label>
              <input
                type="password"
                className="form-control"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                minLength={6}
              />
            </div>
            <button 
              type="submit" 
              className="btn btn-primary"
              disabled={isLoading}
            >
              {isLoading ? 'Đang cập nhật...' : 'Cập nhật mật khẩu'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Profile; 